<section *ngIf='show' style="padding: 20px;padding-bottom: 0 !important;padding-top: 0;" class='no0'>
    <div class="col-12 mt-3">
        <div class="card" style='margin-bottom: 0px !important;'>
            <div class="card-header choose3">
                <h4 style="display:inline-block;">Orders : </h4>
                <button (click)='ref()' style="box-shadow:none;border: 1px solid black;height: 27px;line-height:0;" type="button" class="btn btn-success ml-1"><i class="fas fa-sync-alt"></i></button>
                <button style="box-shadow:none;border: 1px solid black;height: 27px;line-height:0;float:right" type="button" class="btn btn-danger ml-1 delall">{{dateAmOrder}}</button>
                <button (click)='printall()' style="box-shadow:none;border: 1px solid black; float:right;height:27px;line-height:0;" type="button" class="btn btn-success ml-1 delall"><i class="fas fa-print"></i></button>
                <div class='container-fluid'>
                    <div class="row">
                        <div class="col-lg-3">
                            <div class='mt-1 pl-1 lastU'>
                                <select [(ngModel)]='customer_id' name="customer_id" class="form-control mt-4 sO submitNumber select2 goQN" style="height: unset !important;">
                  <option value="undefined" disabled>Customer</option>
                  <option *ngFor='let r of arreCustomer' [value]="r.id">{{r.name}}</option>
                  </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-lg-4 col-12 p-1">
                            <span style=' display: none !important;'>
                          <select disabled [(ngModel)]='Customer' class="form-control select2 select2QC" style="height: 45px !important; width: 100%;border: 1px solid black !important; color: black !important;" disabled>
                        <option disabled>Customer</option>
                        <option *ngFor='let x of arreCustomer' [value]="x.id">{{x.name}}</option>
                </select>
              </span>
                            <form class='nog5 yaa5y0' #data124009='ngForm' style="direction: ltr !important;border:1px solid black">
                                <span id="form00" style="display: block;">
                                <fieldset>
                                  <legend class='ml-2'>Customer Details</legend>
                                <div class='container-fluid pl-1 pr-1' style='padding-bottom: 5px;'>
                                  <div class='row'>
                                    <div class='col-6'>
                                      <input disabled  style='border-color: black !important;' class="text mt-2 d1" type="text" name="nameU" [(ngModel)]='nameU' placeholder="Name" required="">
                                    </div>
                                    <div class='col-6'>
                                      <input disabled  style='border-color: black !important;' class="text mt-2 d1" type="text" name="adressU" [(ngModel)]='adressU' placeholder="Adress" required="">
                                    </div>
                                    <div class='col-6'>
                                      <input disabled  style='border-color: black !important;' class="text mt-2 d1" type="number" name="phoneU" [(ngModel)]='phoneU' placeholder="Phone" required="">
                                    </div>
                                    <div class='col-6'>
                                      <input disabled  style='border-color: black !important;'  class="text mt-2 d1" type="number" name="phone2U" [(ngModel)]='phone2U' placeholder="Phone 2" required="">
                                    </div>
                                    <div class='col-6'>
                                      <select disabled [(ngModel)]='typeU' name="typeU" class="form-control mt-2" style="height: 25px !important; width: 100%; color: black !important;border:1px solid black !important;padding:0 !important;text-align-last: center;">
                                        <option disabled selected value="">Type</option>
                                        <option>Normal</option>
                                        <option>Family</option>
                                        <option>Vip</option>
                                        <option>Project</option>
                                </select></div>
                                    <div *ngIf='upS' class='col-6'>
                                      <input *ngIf='false' disabled  class="mt-2" style="width: 94.5% !important;float: left;color: white !important;line-height: 0;" type="submit" value="Update">
                                    </div>
                                    <div *ngIf='upS0' class='col-6'>
                                    </div>
                                  </div>
                                </div>
                        <div style="clear: both;"></div>
                      </fieldset>
                  </span>
                            </form>
                            <form class='nog5 mt-2 kkloi pb-2 yaa5y0' style="direction: ltr !important;border:1px solid black">
                                <span id="form00" style="display: block;">
                      <fieldset>
                        <legend class='ml-2'>Seller Details</legend>
                      <div class='container-fluid pl-1 pr-1'>
                        <div class='row'>
                          <div class='col-6 mb-2'>
                            <select disabled [(ngModel)]='nameUX' name="nameUX" class="form-control mt-4 sO submitNumber select2 goQN00">
                              <option value="undefined" disabled>Seller</option>
                              <option *ngFor='let r of arreCustomer00' [value]="r.id">{{r.name}}</option>
                              </select> </div>
                        </div>
                      </div>
              <div style="clear: both;"></div>
            </fieldset>
        </span>
                            </form>

                        </div>
                        <div class="col-lg-4 col-12">
                            <form class='nog5 kkloi mt-1 pb-2 yaa5y0' style="direction: ltr !important;border:1px solid black;">
                                <span id="form00" style="display: block;">
    <fieldset>
      <legend class='ml-2'>Broker</legend>
    <div class='container-fluid pr-1 pl-1'>
      <div class='row'>
        <div class='col-6 mb-2'>
          <select disabled [(ngModel)]='nameUX0' name="nameUX0" class="form-control mt-4 sO submitNumber select2 goQN00X0" style="height: unset !important;">
            <option value="undefined" disabled>Broker</option>
            <option *ngFor='let r of arreCustomer000' [value]="r.id">{{r.name}}</option>
            </select>                      </div>
            <div class='col-6 mb-2' style='text-align: right;'>
            </div>
            <form class='nog5 yaa5y0 mt-2' #data1240099='ngForm' style="direction: ltr !important;border:1px solid black">
              <span id="form00" style="display: block;">
                <fieldset>
                  <legend class='ml-2'>Broker Details</legend>
                <div class='container-fluid pl-1 pr-1' style='padding-bottom: 17px;'>
                  <div class='row'>
                    <div class='col-6'>
                      <input disabled  style='border-color: black !important;' class="text mt-2 d1" type="text" name="nameU0" [(ngModel)]='nameU0' placeholder="Name" required="">
                    </div>
                    <div class='col-6'>
                      <input disabled  style='border-color: black !important;' class="text mt-2 d1" type="number" name="phoneU0" [(ngModel)]='phoneU0' placeholder="Phone" required="">
                    </div>
                <div class='col-6'>
                  <label class="mt-2">Commision_Percentage</label>
                  <input disabled  style='border-color: black !important;' class="text d1" type="text" name="commision" [(ngModel)]='commision' placeholder="Commision Percentage" required="">
                </div>
                <div class='col-6'>
                  <label class="mt-2">Commision_Value</label>
                  <input disabled  style='border-color: black !important;' class="text d1" type="text" name="commisionafter" [(ngModel)]='commisionafter' placeholder="Commision Value" required="">
                </div>
                    <div *ngIf='upS' class='col-6'>
                      <input *ngIf='false' disabled  class="mt-2" style="width: 94.5% !important;float: left;color: white !important;line-height: 0;margin-bottom: 9px !important" type="submit" value="Update">
                    </div>
                    <div class='col-6'>
                    </div>
                  </div>
                </div>
        <div style="clear: both;"></div>
      </fieldset>
  </span>
                            </form>
                        </div>
                    </div>
                    <div style="clear: both;"></div>
                    </fieldset>
                    </span>
                    </form>
                </div>
                <div class="col-lg-4 col-12 p-1 kkloi nog5">
                    <form class='yaa5y0' style="direction: ltr !important;border:1px solid black">
                        <span id="form00" style="display: block;">
    <fieldset>
      <legend class='ml-2'>Invoice Info</legend>
    <div class='container-fluid pb-1 pl-1 pr-1'>
      <div class='row'>
        <div class='col-6 mb-2'>
          <select [(ngModel)]='QUotationNo' class="form-control select2 select2Q" style="height: 45px !important; width: 100%;border: 1px solid black !important; color: black !important;">
            <option value='undefined' disabled selected>QUotation No</option>
            <option *ngFor='let x of arre|customerId:yarbs' [value]="x.id">{{x.id}}</option>
    </select>
    </div>
<div class='col-6 mb-2'>
  <input disabled  style='border-color: black !important; width: 96% !important;'  class="text d1" type="text" name='dateAm' [(ngModel)]='dateAm' placeholder="Date" required="" disabled>
</div>
<div class='col-6 mb-2'>
  <label>Total_amount</label>
  <input disabled  style='border-color: black !important;'  class="text d1" type="number" name='alltotal' [(ngModel)]='alltotal' placeholder="Total amount" required="" disabled>
</div>
<div class='col-6 mb-2'>
<label>Total_after_Discound</label>
<input disabled  style='border-color: black !important;'  class="text d1" type="number" name='payAll00' [(ngModel)]='payAll00' placeholder="Total after Discound" required="">
</div>
<div class='col-6 mb-2'>
  <label>Discound_Value</label>
  <input disabled  style='border-color: black !important;'  class="text d1" type="number" name='discoundAllValue' [(ngModel)]='discoundAllValue' placeholder="Discound Value" required="">
  </div>
  <div class='col-6 mb-2'>
  <label>Discound_Percentage</label>
  <input disabled  style='border-color: black !important;'  class="text d1" type="number" name='discoundAll' [(ngModel)]='discoundAll' placeholder="Discound Percentage" required="">
  </div>
<div class='col-6 mb-2'>
<label>Down_Payment</label>
<input disabled  style='border-color: black !important;'  class="text d1" type="number" name='payAll' [(ngModel)]='payAll' placeholder="Down Payment" required="">
</div>
<div class='col-6 mt-3'>
<input  (click)='items0Orderre()' class="mt-2 delall" style="margin-bottom:5px !important;width: 94.5% !important;float: left;color: white !important;line-height: 0;" type="submit" value="Quotation">
</div>
      </div>
    </div>
<div style="clear: both;"></div>
</fieldset>
</span>
                    </form>
                </div>

            </div>
        </div>
    </div>

    <div class='container-fluid choose2'>
        <div class='row'>
            <div class='col-6' style='text-align: center;'>
                <img src='../../assets/video/04377946-bbde-4742-9bef-95d6a362cc0c.jpg'>
            </div>
            <div class="col-6" style='text-align: center;'>
                <h2 style="display: inline-block;">DATE : </h2> {{date}}<br>
                <h2 style="display: inline-block;">Order No . </h2> {{quota}}<br>
            </div>
            <div class="col-6" style='text-align: center;'>
                <div class="card border-light mb-3" style="max-width: 18rem;border:1px solid #80808091 !important;text-align: left;display: inline-block;">
                    <div class="card-header" style='text-align:center;background-color:#80808091; color:black;font-weight:bolder;padding: 0;'>SERVICE PROVIDER</div>
                    <div class="card-body">
                        <h5 class="card-title mb-1">El Shikh Zayed - 2nd Entance - Area 6 - City Mark Mall</h5>
                        <h5 class="card-text">Tel : 0238519333 - 0238519444</h5>
                        <h5 class="card-text">Mobil : 01222222712</h5>
                        <h5 href='www.nogal-furniture.com' style='font-weight: bolder;color: blue;'>www.nogal-furniture.com</h5>
                    </div>
                </div>
            </div>
            <div class="col-6" style='text-align: center;'>
                <div class="card border-light mb-3" style="max-width: 18rem;border:1px solid #80808091 !important;text-align: left;display: inline-block;">
                    <div class="card-header" style='text-align:center;background-color:#80808091; color:black;font-weight:bolder;padding: 0;'>CUSTOMER</div>
                    <div class="card-body">
                        <h5 class="card-title mb-1">Name : {{nameU}}</h5>
                        <h5 class="card-text">Adress : {{adressU}}</h5>
                        <h5 class="card-text">Phone : {{phoneU}}</h5>
                        <h5 class="card-text">Email : {{emailU}}</h5>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <a id='parentDelete' style='overflow: auto;height: 40vh;width:100%;'>

        <table id='parentDelete1' class="responsive-table" style="border-collapse: separate;border-spacing: 0;page-break-inside:auto;" width="100%">
            <thead>
                <tr>
                    <th scope="col" class='choose3'><i class="fas fa-check"></i></th>
                    <th style="text-align: center;" class='choose3'>No.</th>
                    <th scope="col">Photo</th>
                    <th scope="col" class='choose3'>Item_Code</th>
                    <th scope="col" class='choose3'>Branch</th>
                    <th scope="col">Description</th>
                    <!-- <th scope="col">Finishing/fabrics</th> -->
                    <th scope="col">Dimensions</th>
                    <th scope="col">Current Price</th>
                    <th scope="col">Qty</th>
                    <th scope="col">Current Total_Coast</th>
                    <th scope="col">{{Price_Seller}}</th>
                    <th scope="col">Net_Amount</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor='let v of arre00|itemmin0; let n = index;'>
                    <th scope="row" style="text-align: center;" class='choose3'><input type="checkbox"></th>
                    <th scope="row" style="text-align: center;" class='choose3'>{{n+1}}</th>
                    <td data-title="Photo">
                        <img (click)='showpho(v.id_item)' (mouseenter)='goPic(v.url)' (mouseleave)='goPic0()' style='width:70px;height:70px;cursor: pointer;' [src]='(v.url != null) ? v.url : "../../assets/video/noimage.jpg" '>
                    </td>
                    <td data-title="Item_Code" class='choose3'>{{v.itemcode}}</td>
                    <td data-title="Branch" class='choose3'>{{v.rootname}}</td>
                    <td data-title="Description">
                        <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.description}}</a></div>
                    </td>
                    <!-- <td data-title="Finishing/fabrics">
                        <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.fabric}}</a></div>
                    </td> -->
                    <td data-title="Dimensions">
                        <div style="max-width:90px;display: inline-block;"><a style='display: block;'>{{v.dimensions}}</a></div>
                    </td>
                    <td data-title="Current Price">{{v.price}}</td>
                    <td data-title="Qty">{{v.qty}}</td>
                    <td data-title="Current Total_Coast">{{v.price * v.qty}}</td>
                    <td data-title="{{Price_Seller}}">{{v.priceSeller}}</td>
                    <td data-title="Net_Amount" class='prinee'>{{v.total}}</td>
                </tr>
                <tr *ngIf='choose2' style='background-color:white !important;'>
                    <td style='opacity:0 !important;'></td>
                    <td style='opacity:0 !important;'></td>

                    <td style='opacity:0 !important;'></td>
                    <td style='opacity:0 !important;'></td>
                    <td style='opacity:0 !important;'></td>
                    <td style='opacity:0 !important;'></td>
                    <td data-title="TOTAL" style="text-align: right; font-weight: bolder;border: 0 !important;">TOTAL : </td>
                    <td data-title="TOTAL">{{alltotal}}</td>
                </tr>
                <ng-container *ngIf='discoundAllValue > 0'>
                    <tr *ngIf='choose2' style='background-color:white !important;'>
                        <td style='opacity:0 !important;'></td>
                        <td style='opacity:0 !important;'></td>
                        <td style='opacity:0 !important;'></td>
                        <td style='opacity:0 !important;'></td>
                        <td style='opacity:0 !important;'></td>
                        <td style='opacity:0 !important;'></td>
                        <td data-title="Special Discount" style="text-align: right;font-weight: bolder;border: 0 !important;">Special Discount : </td>
                        <td data-title="Special Discount">{{discoundAllValue}}</td>
                    </tr>
                </ng-container>
                <ng-container *ngIf='discoundAllValue > 0'>
                    <tr *ngIf='choose2' style='background-color:white !important;'>
                        <td style='opacity:0 !important;'></td>
                        <td style='opacity:0 !important;'></td>
                        <td style='opacity:0 !important;'></td>
                        <td style='opacity:0 !important;'></td>
                        <td style='opacity:0 !important;'></td>
                        <td style='opacity:0 !important;'></td>
                        <td data-title="TOTAL After Dis" style="text-align: right;font-weight: bolder;border: 0 !important;">TOTAL After Dis : </td>
                        <td data-title="TOTAL After Dis">{{payAll00}}</td>
                    </tr>
                </ng-container>
                <ng-container *ngIf='choose2'>

                    <tr *ngFor='let v of arre0987; let n = index;' style='background-color:white !important;'>
                        <td style='opacity:0 !important;'></td>
                        <td style='opacity:0 !important;'></td>
                        <td style='opacity:0 !important;'></td>
                        <td style='opacity:0 !important;'></td>
                        <td style='opacity:0 !important;'></td>
                        <td style='opacity:0 !important;'></td>
                        <td data-title="TOTAL After Dis" style="text-align: right;font-weight: bolder;border: 0 !important;">{{v.date|date:'dd-MM-yyyy'}} </td>
                        <td data-title="TOTAL After Dis">{{v.money}}</td>
                    </tr>
                </ng-container>
                <tr *ngIf='choose2' style='background-color:white !important;'>
                    <td style='opacity:0 !important;'></td>
                    <td style='opacity:0 !important;'></td>
                    <td style='opacity:0 !important;'></td>
                    <td style='opacity:0 !important;'></td>
                    <td style='opacity:0 !important;'></td>
                    <td style='opacity:0 !important;'></td>
                    <td data-title="TOTAL After Dis" style="text-align: right;font-weight: bolder;border: 0 !important;">Total Payed : </td>
                    <td data-title="TOTAL After Dis">{{payAll}}</td>
                </tr>
                <tr *ngIf='choose2' style='background-color:white !important;'>
                    <td style='opacity:0 !important;'></td>
                    <td style='opacity:0 !important;'></td>
                    <td style='opacity:0 !important;'></td>
                    <td style='opacity:0 !important;'></td>
                    <td style='opacity:0 !important;'></td>
                    <td style='opacity:0 !important;'></td>
                    <td data-title="TOTAL After Dis" style="text-align: right;font-weight: bolder;border: 0 !important;">Remaining : </td>
                    <td data-title="TOTAL After Dis">{{payAll00 - payAll}}</td>
                </tr>
            </tbody>
        </table>
    </a>
    <p *ngIf='choose2' style="font-size: 17px;font-weight: bolder;" class='mt-4'>Noticeable : ‐</p>
    <p *ngIf='choose2' style="font-size: 17px;">* Prices doesn't include VAT or any other taxes.</p>
    <p *ngIf='choose2' style="font-size: 17px;">* This offer includes supply and installation</p>
    <p *ngIf='choose2' style="font-size: 17px;">* This offer is valid for one week.</p>
    <p *ngIf='choose2' class="mt-3" style="font-size: 17px;font-weight: bolder;text-align: center;color: black;">THANK YOU</p>
    <img class='shadow-lg' *ngIf='goImg' style='position: fixed;top:0;bottom: 0;right:0;left:0;margin-right: auto;margin-left: auto;margin-bottom: auto;margin-top: auto;z-index: 200000;' [src]='www'>



    </div>
    </div>
</section>
<section class="loading">
    <div class="spinner">
        <div class="sk-circle">
            <div class="sk-circle1 sk-child"></div>
            <div class="sk-circle2 sk-child"></div>
            <div class="sk-circle3 sk-child"></div>
            <div class="sk-circle4 sk-child"></div>
            <div class="sk-circle5 sk-child"></div>
            <div class="sk-circle6 sk-child"></div>
            <div class="sk-circle7 sk-child"></div>
            <div class="sk-circle8 sk-child"></div>
            <div class="sk-circle9 sk-child"></div>
            <div class="sk-circle10 sk-child"></div>
            <div class="sk-circle11 sk-child"></div>
            <div class="sk-circle12 sk-child"></div>
        </div>
    </div>
</section>